// extracted by mini-css-extract-plugin
export var container = "letsTalkForm-module--container--1N1Lz";
export var pipcWrap = "letsTalkForm-module--pipcWrap--2Sg5Y";
export var title = "letsTalkForm-module--title--ATKmZ";
export var title_inner = "letsTalkForm-module--title_inner--1ughf";
export var formWrap = "letsTalkForm-module--formWrap--nGQtb";
export var svgWrap = "letsTalkForm-module--svgWrap--2zR4h";